import config from '@/config';
import { datadogRum } from '@datadog/browser-rum';
import type { RumEvent } from '@datadog/browser-rum';

if (!config.isTest && !config.isDevelopment) {
  const DISCARD_EVENTS = [
    /Uncaught "Object Not Found Matching Id:3, MethodName:update, ParamCount:4"/i,
    /Uncaught "Object Not Found Matching Id:2, MethodName:update, ParamCount:4"/i,
    /Uncaught "ResizeObserver loop completed with undelivered notifications."/i,
    /ResizeObserver loop limit exceeded/i,
    /Network Error/i,
    /Server error./i,
    /Uncaught "Script error."/i
  ];

  const shouldDiscardEvent = (event: RumEvent) => {
    if (event.type !== 'error') {
      return false;
    }
    if (event.error?.source === 'report') {
      return true;
    }
    return !!DISCARD_EVENTS.find((regex) =>
      regex.test(String(event.error?.message))
    );
  };

  datadogRum.init({
    applicationId: '67009f4a-a3e9-496a-bb1d-406aab2a34a0',
    clientToken: 'pub001904998b42eb71d66052b05d9d1e73',
    site: 'datadoghq.eu',
    service: 'booking-widget-2',
    env: config.env,
    sessionSampleRate: config.isProduction ? 2 : 100,
    sessionReplaySampleRate: config.isProduction ? 5 : 100,
    traceSampleRate: config.isProduction ? 10 : 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event: RumEvent) => shouldDiscardEvent(event)
  });
}
